<template>
    <ul>
            <li v-for="item in newsInfo" class="vCenter" :data-url=item.newsid>
              <div class="left">
                <img :src="item.cover" alt="" v-if="item.cover">
                <div class="defaultcover" v-else-if="!item.cover">
                  默 认
                </div>
              </div>
              <div class="mid">
                <div class="newsTitle" @click="showDeatil(item)">
                    {{item.newscaption}}
                </div>
                <div class="synopsis">
                  {{item.synopsis}}
                </div>
                <div class="vCenter">
                  <div class="newsType">
                    {{item.typename}}
                  </div>
                  <div class="author vCenter">
                    {{item.sumname}}
                  </div>
                  <div class="praise vCenter">
                    {{item.praisecount}}赞
                  </div>
                  <div class="comments vCenter">
                    {{item.reviewcount}}评论
                  </div>
                  <div class="time">  
                    {{item.createdate}}
                  </div>
                </div>
              </div>
              <div class="right">

              </div>
            </li>
          </ul>
</template>
<script>
export default {
  name:'UmList',
    data(){
        return{

        }
    },
    props: ["newsInfo"],
    methods:{
        showDeatil(item){
          localStorage.setItem('newsid',item.newsid)
            this.$emit('retiteminfo',item);
        }
    }
}
</script>

<style lang="scss" scoped>
ul {
    padding: 0 30px;
    li {
      border-bottom: 1px solid #dcdcdc;
      padding: 20px 0;
      .left {
        width: 190px;
        height: 124px;
        margin-right: 30px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .mid {
        .newsTitle {
          font-size: 20px;
          font-weight: bold;
          color: #333;
          margin-bottom: 10px;
          cursor: pointer;
        }
        .synopsis{
          margin-bottom: 10px;
          font-size: 16px;
          width: 40vw;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space:nowrap;
        }
        > div {
          color: #999999;
          > div {
            margin-right: 10px;
          }
          .author:after,
          .praise:after,
          .comments:after {
            content: "";
            display: inline-block;
            width: 2px;
            height: 2px;
            background: #999;
            border-radius: 50%;
            margin-left: 10px;
          }
          .newsType {
            font-size: 14px;
            border: 1px solid;
            border-radius: 8px;
            padding: 1px 8px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/packages/list/um-list.vue